function reviveScripts(container) {
  // <script> tags cloned out of a <template> (which is how quick-buy-modal injects its content) never execute on
  // their own — the browser only runs a <script> the first time it's parsed as part of a live document. App blocks
  // (Swym included) rely on an inline <script> running every time their block is inserted, so we have to manually
  // recreate each one to force execution.
  container.querySelectorAll('script').forEach((oldScript) => {
    const newScript = document.createElement('script');

    Array.from(oldScript.attributes).forEach((attribute) => {
      newScript.setAttribute(attribute.name, attribute.value);
    });

    newScript.textContent = oldScript.textContent;
    oldScript.replaceWith(newScript);
  });
}

document.addEventListener(
  'dialog:after-show',
  (event) => {
    const modal = event.target;

    if (!(modal instanceof HTMLElement) || modal.tagName.toLowerCase() !== 'quick-buy-modal') return;

    reviveScripts(modal);

    const variantScript = modal.querySelector('script[data-variant]');
    let productId = null;

    if (variantScript) {
      try {
        productId = JSON.parse(variantScript.textContent || '{}').product_id ?? null;
      } catch {
        productId = null;
      }
    }

    document.dispatchEvent(
      new CustomEvent('quickview:loaded', {
        detail: { productId },
      })
    );
  },
  true
);

function swymCallbackFn(swat) {
  console.log('[swym-debug] swymCallbackFn registered with swat:', swat);
  console.log('[swym-debug] typeof initializeActionButtons:', typeof swat?.initializeActionButtons);

  function swymAttachEvents() {
    const btnBefore = document.querySelector('.quick-buy-modal [id^="swym-atw-pdp-button"]');
    console.log('[swym-debug] button before init:', btnBefore, btnBefore?.outerHTML);

    // .quick-buy-modal is the class already present on every <quick-buy-modal> element in this theme
    const result = swat.initializeActionButtons('.quick-buy-modal');
    console.log('[swym-debug] initializeActionButtons returned:', result);

    setTimeout(() => {
      const btnAfter = document.querySelector('.quick-buy-modal [id^="swym-atw-pdp-button"]');
      console.log('[swym-debug] button 500ms after init:', btnAfter, btnAfter?.outerHTML);
    }, 500);
  }

  document.addEventListener('quickview:loaded', function (e) {
    console.log('Quickview Loaded!', e.detail.productId);
    swymAttachEvents();
  });

  document.addEventListener('variant:change', function (event) {
    var variantId = event.detail.variant.id;
    var btn = document.querySelector('.quick-buy-modal [id^="swym-atw-pdp-button"]');

    if (btn) {
      btn.setAttribute('data-variant-id', variantId);
    }

    swymAttachEvents();
  });
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}

window.SwymCallbacks.push(swymCallbackFn);
